/* @flow */

/* @jsx jsxDom */

/* eslint max-lines: 0 */
import { create } from "zoid";
import {
  WALLONIE,
  BRUXELLES,
  HABITATION,
  TERRAIN,
  AUTRE_TYPE_IMMEUBLE
} from "../../store/constants/questions";
export let EasyScaleButton = create({
  tag: "button",

  defaultEnv: "development",

  url: {
    development: "./button.html",
    production: "https://embed.easyscale.be/button.html"
  },

  domain: {
    test: "mock://www.my-site.com"
  },

  props: {
    sourceUrl: {
      type: "string",
      required: false,
      value() {
        return window.location.href;
      }
    },
    organisationId: {
      type: "string",
      required: true
    },
    prix: {
      type: "number",
      required: true
    },
    typeBien: {
      type: "string",
      required: false,
      validate: function(value, props) {
        return (
          value === HABITATION ||
          value === TERRAIN ||
          value === AUTRE_TYPE_IMMEUBLE ||
          value === undefined
        );
      }
    },
    region: {
      type: "string",
      required: true,
      validate: function(value, props) {
        return value === WALLONIE || value === BRUXELLES;
      }
    }
  },

  defaultContext: "iframe",
  dimensions: {
    height: "90px",
    width: "360px"
  },
  contexts: {
    iframe: true,
    popup: false
  }
});



// WEBPACK FOOTER //
// ./src/zoid/button/component.jsx